<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-check-circle"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Almost there</h2>
                <p>Set a password and confirm your mobile number to activate your Sovos account.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-key"></i><span>8 to 16 characters — memorable but secure</span></li>
                    <li><i class="fa fa-asterisk"></i><span>Mix upper, lower, number and symbol</span></li>
                    <li><i class="fa fa-mobile"></i><span>Mobile number for notifications and recovery</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="completeRegForm" class="login-form" autocomplete="off"
                (ngSubmit)="completeRegistration()">
                <h1 class="login-title">Complete registration</h1>
                <p class="login-subtitle">Welcome {{ username }}</p>

                <div class="login-field">
                    <label for="regPassword">Password</label>
                    <input type="password" class="login-input passdisc" formControlName="password" id="regPassword"
                        placeholder="Set Password">
                    <div *ngIf="isSubmitted">
                        <span class="login-error"
                            *ngIf="!completeRegForm.get('password').dirty && completeRegForm.get('password').errors?.required">Password Required</span>
                        <span class="login-error"
                            *ngIf="completeRegForm.get('password').dirty && completeRegForm.get('password').errors">Invalid Password</span>
                    </div>
                </div>

                <div class="login-field">
                    <label for="regPhone">Mobile number</label>
                    <input type="number" class="login-input" formControlName="phone" id="regPhone"
                        placeholder="Mobile number">
                    <div *ngIf="isSubmitted">
                        <span class="login-error"
                            *ngIf="!completeRegForm.get('phone').dirty && completeRegForm.get('phone').errors?.required">Mobile Number Required</span>
                        <span class="login-error"
                            *ngIf="completeRegForm.get('phone').dirty && completeRegForm.get('phone').errors">Invalid Mobile Number</span>
                    </div>
                </div>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit">COMPLETE REGISTRATION</button>
            </form>
        </section>
    </div>
</div>
